import { request } from "apis/base";
import { CommonParamsType } from "constants/types/common";
import {
  DeactiveUserBodyType,
  PasswordResetBodyType,
  UserRequestBodyType,
  UserUpdateBodyType,
} from "constants/types/user";

export const userApi = {
  getUsers: (params: CommonParamsType) => {
    return request({
      url: "/user",
      method: "GET",
      params,
    });
  },

  getUserById: (id: string) => {
    return request({
      url: `/user/${id}`,
      method: "GET",
    });
  },

  createUser: (data: UserRequestBodyType) => {
    return request({
      url: "/user",
      method: "POST",
      data,
    });
  },

  updatePhoneRoleUser: (id: string, data: UserUpdateBodyType) => {
    return request({
      url: `/user/${id}`,
      method: "PUT",
      data,
    });
  },

  resetPassword: (id: string, data: PasswordResetBodyType) => {
    return request({
      url: `/user/${id}`,
      method: "PUT",
      data,
    });
  },

  deactiveUser: (
    id: string,
    data: DeactiveUserBodyType = { isActive: false },
  ) => {
    return request({
      url: `/user/${id}`,
      method: "PUT",
      data,
    });
  },

  deleteUser: (id: string) => {
    return request({
      url: `/user/${id}`,
      method: "DELETE",
    });
  },
};
